import { Controller, useFormContext } from 'react-hook-form';
import { ComboboxField } from 'components/DesignSystems/ComboboxField/ComboboxField';
import { useResourceSets } from 'components/IAP/hooks/resourceSetHooks';
import type { EventFormValues } from './eventForm';

const AssetsAtRiskSection: React.FC = () => {
  const { control } = useFormContext<EventFormValues>();
  const { data: resourceSets } = useResourceSets();

  return (
    <Controller
      control={control}
      name="resourceSetIds"
      render={({ field }) => (
        <ComboboxField
          label="Assets at Risk"
          multiple
          options={(resourceSets ?? [])
            .filter((resourceSet) => !resourceSet.archived)
            .map((resourceSet) => ({
              value: resourceSet.resource_set_id,
              label: resourceSet.name,
            }))}
          placeholder="Select resource sets at risk (optional)"
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
  );
};

export default AssetsAtRiskSection;
